<div class="format-container row align-items-center flex-column pb-20">
  <div class="col-12 mt-20 top-section d-flex align-items-center flex-column">
    <div class="text-center">
      <h3 i18n="@@formatInputTitle">What content do you want to turn into audio?</h3>
      <div class="subtitle mt-20" i18n="@@formatInputSubtitle">
        Tell us what kind of source or content you have in mind.
      </div>
    </div>

    <div class="tagus-form-group mt-32 w-100">
      <label class="d-block mb-12 fw-semibold">
        <ng-container i18n="@@yourTextFormat">Content source</ng-container> <span>*</span>
      </label>
      <mat-form-field appearance="fill">
        <i class="ri-file-text-line"></i>
        <mat-label i18n="@@enterTextFormat">Enter a source or content type</mat-label>
        <input
          #formatInput
          matInput
          placeholder="Research papers, newsletters, videos"
          type="text"
          [formControl]="format"
          (keyup.enter)="enterPressed()"
          required
        />
        @if (format.invalid) {
          <mat-error i18n="@@formatInvalid">Content source is required</mat-error>
        }
      </mat-form-field>
    </div>

    <button
      mat-flat-button
      class="tagus mt-32"
      [disabled]="isInvalid()"
      (click)="continueButtonClicked()"
    >
      <ng-container i18n="@@continue">Continue</ng-container>
    </button>
  </div>
</div>
